/**
 * Integration Center — domain types (Sprint 2.2).
 * Integrations are registered as data — never hardcoded in app logic.
 */

export const INTEGRATION_CATEGORIES = [
  'Fornecedor',
  'Marketplace',
  'IA',
  'Mensageria',
  'ERP',
  'Financeiro',
  'Email',
  'Outros',
] as const

export type IntegrationCategory = (typeof INTEGRATION_CATEGORIES)[number]

export const INTEGRATION_STATUSES = [
  'Nunca conectado',
  'Conectando',
  'Conectado',
  'Erro',
  'Expirado',
  'Desativado',
] as const

export type IntegrationStatus = (typeof INTEGRATION_STATUSES)[number]

export type IntegrationTipo =
  | 'api'
  | 'oauth'
  | 'scraping'
  | 'webhook'
  | 'smtp'
  | 'sdk'
  | 'manual'
  | 'outro'

export interface IntegrationRecord {
  id: string
  nome: string
  categoria: IntegrationCategory
  tipo: IntegrationTipo
  status: IntegrationStatus
  ativo: boolean
  icone: string
  url: string
  usuario: string
  senha: string
  apiKey: string
  token: string
  cookies: string
  headers: Record<string, string>
  prioridade: number
  ultimaConexao: string | null
  ultimoErro: string | null
  versao: string
}

export interface IntegrationCenterFile {
  version: string
  updatedAt: string
  integrations: IntegrationRecord[]
}

export interface IntegrationActionResult {
  ok: boolean
  message: string
  placeholder: true
  integrationId: string
  action: 'test' | 'connect' | 'disconnect' | 'logs' | 'edit'
}

export type IntegrationPatch = Partial<
  Omit<IntegrationRecord, 'id'> & {
    headers?: Record<string, string>
  }
>
